// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Liste des entreprises qui n’ont pas publié d’offre d’emploi mais qui sont susceptibles d’embaucher des apprentis dans le domaine souhaité.\n\nLes résultats sont limités à 150, et actuellement, il n’est pas possible de retrouver tous les recruteurs correspondant aux critères de recherche.\n"
export default markdown
